import PictureUpload from 'tools/Picture/Upload'

import DefaultBook from './DefaultBook'
import DefaultOrg from './DefaultOrg'
import DefaultUser from './DefaultUser'

export const COLORS = [
  '#FF7401',
  '#FEBD15',
  '#8FDC35',
  '#58D53E',
  '#29EA4E',
  '#30E191',
  '#1FE0BA',
  '#02CDF8',
  '#0077FF',
  '#0219FE',
  '#6900FE',
  '#A300FF',
  '#FF00FF',
  '#FE00A1',
  '#FF0246',
  '#FF1900'
]

// NOTE: Changing these effects the size of uploaded things as well as display
export const PSIZES = {
  tiny: { height: '1.5rem' },
  thumb: { height: '4rem' },
  tile: { width: '7rem', height: '10.5rem' },
  display: { width: '12.5rem', height: '18.75rem' },
  upload: { width: '25rem', height: '37.5rem' }
}

export const USIZES = {
  thumb: { width: '1.5rem', height: '1.5rem' },
  tile: { width: '3rem', height: '3rem' },
  display: { width: '9rem', height: '9rem' },
  upload: { width: '18rem', height: '18rem' }
}

export const OSIZES = {
  thumb: { width: '1.5rem', height: '1.5rem' },
  tile: { width: '5rem', height: '5rem' },
  display: { width: '18rem', height: '18rem' },
  upload: { width: '18rem', height: '18rem' }
}

////////////////////////////////////////////////////////////////////////////////
export function UserAvatar({ origin, avatar, size, config, className }) {
  return showAvatar({
    origin,
    avatar,
    className,
    config: config || USIZES[size],
    Default: DefaultUser
  })
}

export function EditUserAvatar({ origin, onSave }) {
  return (
    <PictureUpload
      origin={origin}
      subject="user"
      upload={USIZES.upload}
      display={USIZES.display}
      Display={UserAvatar}
      onSave={onSave}
      canEdit={true}
      className="br-pill overflow-hidden"
      alt="User Avatar"
    />
  )
}

////////////////////////////////////////////////////////////////////////////////
export function ProjectAvatar({
  origin,
  avatar,
  size,
  config,
  className = 'db'
}) {
  return showAvatar({
    className,
    origin,
    avatar,
    config: config || PSIZES[size],
    Default: DefaultBook
  })
}

export const MeetAvatar = ProjectAvatar

export function EditProjectAvatar({ origin, onSave }) {
  return (
    <PictureUpload
      origin={origin}
      subject="project"
      round={false}
      onSave={onSave}
      upload={PSIZES.upload}
      display={PSIZES.display}
      canEdit={true}
      alt="Cover Picture"
      Display={ProjectAvatar}
    />
  )
}

////////////////////////////////////////////////////////////////////////////////
export function OrgAvatar({ origin, avatar, size, config, className }) {
  return showAvatar({
    className,
    origin,
    avatar,
    config: config || OSIZES[size],
    Default: DefaultOrg
  })
}

export function EditOrgAvatar({ origin, onSave }) {
  return (
    <PictureUpload
      origin={origin}
      subject="org"
      round={false}
      onSave={onSave}
      upload={OSIZES.upload}
      display={OSIZES.display}
      canEdit={true}
      alt="Logo"
      Display={OrgAvatar}
    />
  )
}

////////////////////////////////////////////////////////////////////////////////
function showAvatar({ origin, avatar, config, className = 'db', Default }) {
  const url = avatar?.url || origin?.avatar?.url
  if (url) {
    return <img src={url} alt="avatar" style={config} className={className} />
  } else {
    const seed = avatar?.seed || origin?.avatar?.seed
    const color = COLORS[seed] || '#999'
    return (
      <Default seed={seed} config={config} color={color} className={className} />
    )
  }
}
